import React from "react"
import {withRouter} from "react-router-dom"
import {ClubMemberContextProvider} from "./store/useClubMemberContext"
import ClubMemberSearch from "./component/ClubMemberSearch"
import ClubMemberTable from "./component/ClubMemberTable"
import {Card, Space} from "antd"

const ClubMemberList = () => {
    return (
        <div>
            <ClubMemberContextProvider>
                <Space direction={"vertical"}  style={{width:'100%'}}>
                    <Card>
                        <ClubMemberSearch/>
                    </Card>
                    <Card
                        title={"会员列表"}
                    >
                        <ClubMemberTable/>
                    </Card>
                </Space>
            </ClubMemberContextProvider>
        </div>
    )

}
export default withRouter(ClubMemberList)



// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/index.js